module.exports = __webpack_public_path__ + "static/media/ding-sound.50e87879.mp3";